export const GET_PIECE_DETAILS = 'GET_PIECE_DETAILS';
export const GET_PIECE_DETAILS_SUCCESS = 'GET_PIECE_DETAILS_SUCCESS';
export const GET_PIECE_DETAILS_FAIL = 'GET_PIECE_DETAILS_FAIL';
